import { combineReducers } from 'redux'
import { routerReducer as router } from 'react-router-redux'

import authentication from 'internal-components/src/redux/modules/authentication'
import autocomplete from 'internal-components/src/redux/modules/autocomplete'
import billingGroup from 'internal-components/src/redux/modules/billingGroup'
import client from 'internal-components/src/redux/modules/client'
import coupon from 'internal-components/src/redux/modules/coupon'
import invoice from 'internal-components/src/redux/modules/invoice'
import loading from 'internal-components/src/redux/modules/loading'
import meta from 'internal-components/src/redux/modules/meta'
import partner from 'internal-components/src/redux/modules/partner/reducer'
import payment from 'internal-components/src/redux/modules/payment'
import paymentToken from 'internal-components/src/redux/modules/paymentToken'
import product from 'internal-components/src/redux/modules/product'
import service from 'internal-components/src/redux/modules/service/reducer'
import signup from 'internal-components/src/redux/modules/signup/reducer'
import user from 'internal-components/src/redux/modules/user'

import signupEdit from './signupEdit/reducer'

export default combineReducers({
  authentication,
  autocomplete,
  billingGroup,
  client,
  coupon,
  invoice,
  loading,
  meta,
  partner,
  payment,
  paymentToken,
  product,
  router,
  service,
  signup,
  signupEdit,
  user,
})



// WEBPACK FOOTER //
// ./src/redux/modules/index.js